import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-fitmed-logo-white',
    templateUrl: './fitmed-logo-white.component.html',
    styleUrls: ['./fitmed-logo-white.component.scss'],
    standalone: true
})
export class FitmedLogoWhiteComponent {
  @Input() large = false;
}
